/**
 * Hub Medical
 * Hub medical Consorcio
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { PagedModel } from '../model/pagedModel';
// @ts-ignore
import { SearchServiceRequest } from '../model/searchServiceRequest';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class SearchServiceControllerService {

    protected basePath = 'http://localhost:8080';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
            if (firstBasePath != undefined) {
                basePath = firstBasePath;
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * @param searchServiceRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public search(searchServiceRequest: SearchServiceRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<PagedModel>;
    public search(searchServiceRequest: SearchServiceRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<HttpResponse<PagedModel>>;
    public search(searchServiceRequest: SearchServiceRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<HttpEvent<PagedModel>>;
    public search(searchServiceRequest: SearchServiceRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json',}): Observable<any> {
        if (searchServiceRequest === null || searchServiceRequest === undefined) {
            throw new Error('Required parameter searchServiceRequest was null or undefined when calling search.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (bearerAuth) required
        localVarCredential = this.configuration.lookupCredential('bearerAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }



        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/search_service`;
        return this.httpClient.request<PagedModel>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                body: searchServiceRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param searchServiceRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchDemand(searchServiceRequest: SearchServiceRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<PagedModel>;
    public searchDemand(searchServiceRequest: SearchServiceRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<HttpResponse<PagedModel>>;
    public searchDemand(searchServiceRequest: SearchServiceRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<HttpEvent<PagedModel>>;
    public searchDemand(searchServiceRequest: SearchServiceRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json',}): Observable<any> {
        if (searchServiceRequest === null || searchServiceRequest === undefined) {
            throw new Error('Required parameter searchServiceRequest was null or undefined when calling searchDemand.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (bearerAuth) required
        localVarCredential = this.configuration.lookupCredential('bearerAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }



        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/search_service/demand`;
        return this.httpClient.request<PagedModel>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                body: searchServiceRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param councilGroup 
     * @param professionName 
     * @param specialty 
     * @param activityAreas 
     * @param adultCare 
     * @param pediatricCare 
     * @param serviceFormatOnLine 
     * @param serviceFormatPresential 
     * @param state 
     * @param referenceCity 
     * @param amountMin 
     * @param amountMax 
     * @param billingUnit 
     * @param status 
     * @param availability 
     * @param emergencyServiceAvailability 
     * @param page 
     * @param size 
     * @param sortBy 
     * @param sortDirection 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchDemandGet(councilGroup?: string, professionName?: string, specialty?: string, activityAreas?: Array<string>, adultCare?: boolean, pediatricCare?: boolean, serviceFormatOnLine?: boolean, serviceFormatPresential?: boolean, state?: string, referenceCity?: Array<string>, amountMin?: number, amountMax?: number, billingUnit?: string, status?: string, availability?: Array<number>, emergencyServiceAvailability?: Array<number>, page?: number, size?: number, sortBy?: string, sortDirection?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<PagedModel>;
    public searchDemandGet(councilGroup?: string, professionName?: string, specialty?: string, activityAreas?: Array<string>, adultCare?: boolean, pediatricCare?: boolean, serviceFormatOnLine?: boolean, serviceFormatPresential?: boolean, state?: string, referenceCity?: Array<string>, amountMin?: number, amountMax?: number, billingUnit?: string, status?: string, availability?: Array<number>, emergencyServiceAvailability?: Array<number>, page?: number, size?: number, sortBy?: string, sortDirection?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<HttpResponse<PagedModel>>;
    public searchDemandGet(councilGroup?: string, professionName?: string, specialty?: string, activityAreas?: Array<string>, adultCare?: boolean, pediatricCare?: boolean, serviceFormatOnLine?: boolean, serviceFormatPresential?: boolean, state?: string, referenceCity?: Array<string>, amountMin?: number, amountMax?: number, billingUnit?: string, status?: string, availability?: Array<number>, emergencyServiceAvailability?: Array<number>, page?: number, size?: number, sortBy?: string, sortDirection?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<HttpEvent<PagedModel>>;
    public searchDemandGet(councilGroup?: string, professionName?: string, specialty?: string, activityAreas?: Array<string>, adultCare?: boolean, pediatricCare?: boolean, serviceFormatOnLine?: boolean, serviceFormatPresential?: boolean, state?: string, referenceCity?: Array<string>, amountMin?: number, amountMax?: number, billingUnit?: string, status?: string, availability?: Array<number>, emergencyServiceAvailability?: Array<number>, page?: number, size?: number, sortBy?: string, sortDirection?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json',}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (councilGroup !== undefined && councilGroup !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>councilGroup, 'councilGroup');
        }
        if (professionName !== undefined && professionName !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>professionName, 'professionName');
        }
        if (specialty !== undefined && specialty !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>specialty, 'specialty');
        }
        if (activityAreas) {
            activityAreas.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'activityAreas');
            })
        }
        if (adultCare !== undefined && adultCare !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>adultCare, 'adultCare');
        }
        if (pediatricCare !== undefined && pediatricCare !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>pediatricCare, 'pediatricCare');
        }
        if (serviceFormatOnLine !== undefined && serviceFormatOnLine !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>serviceFormatOnLine, 'serviceFormatOnLine');
        }
        if (serviceFormatPresential !== undefined && serviceFormatPresential !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>serviceFormatPresential, 'serviceFormatPresential');
        }
        if (state !== undefined && state !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>state, 'state');
        }
        if (referenceCity) {
            referenceCity.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'referenceCity');
            })
        }
        if (amountMin !== undefined && amountMin !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>amountMin, 'amountMin');
        }
        if (amountMax !== undefined && amountMax !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>amountMax, 'amountMax');
        }
        if (billingUnit !== undefined && billingUnit !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>billingUnit, 'billingUnit');
        }
        if (status !== undefined && status !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>status, 'status');
        }
        if (availability) {
            availability.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'availability');
            })
        }
        if (emergencyServiceAvailability) {
            emergencyServiceAvailability.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'emergencyServiceAvailability');
            })
        }
        if (page !== undefined && page !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>page, 'page');
        }
        if (size !== undefined && size !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>size, 'size');
        }
        if (sortBy !== undefined && sortBy !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>sortBy, 'sortBy');
        }
        if (sortDirection !== undefined && sortDirection !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>sortDirection, 'sortDirection');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (bearerAuth) required
        localVarCredential = this.configuration.lookupCredential('bearerAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }



        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/search_service/demand`;
        return this.httpClient.request<PagedModel>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param councilGroup 
     * @param professionName 
     * @param specialty 
     * @param activityAreas 
     * @param adultCare 
     * @param pediatricCare 
     * @param serviceFormatOnLine 
     * @param serviceFormatPresential 
     * @param state 
     * @param referenceCity 
     * @param amountMin 
     * @param amountMax 
     * @param billingUnit 
     * @param status 
     * @param availability 
     * @param emergencyServiceAvailability 
     * @param page 
     * @param size 
     * @param sortBy 
     * @param sortDirection 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchGet(councilGroup?: string, professionName?: string, specialty?: string, activityAreas?: Array<string>, adultCare?: boolean, pediatricCare?: boolean, serviceFormatOnLine?: boolean, serviceFormatPresential?: boolean, state?: string, referenceCity?: Array<string>, amountMin?: number, amountMax?: number, billingUnit?: string, status?: string, availability?: Array<number>, emergencyServiceAvailability?: Array<number>, page?: number, size?: number, sortBy?: string, sortDirection?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<PagedModel>;
    public searchGet(councilGroup?: string, professionName?: string, specialty?: string, activityAreas?: Array<string>, adultCare?: boolean, pediatricCare?: boolean, serviceFormatOnLine?: boolean, serviceFormatPresential?: boolean, state?: string, referenceCity?: Array<string>, amountMin?: number, amountMax?: number, billingUnit?: string, status?: string, availability?: Array<number>, emergencyServiceAvailability?: Array<number>, page?: number, size?: number, sortBy?: string, sortDirection?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<HttpResponse<PagedModel>>;
    public searchGet(councilGroup?: string, professionName?: string, specialty?: string, activityAreas?: Array<string>, adultCare?: boolean, pediatricCare?: boolean, serviceFormatOnLine?: boolean, serviceFormatPresential?: boolean, state?: string, referenceCity?: Array<string>, amountMin?: number, amountMax?: number, billingUnit?: string, status?: string, availability?: Array<number>, emergencyServiceAvailability?: Array<number>, page?: number, size?: number, sortBy?: string, sortDirection?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<HttpEvent<PagedModel>>;
    public searchGet(councilGroup?: string, professionName?: string, specialty?: string, activityAreas?: Array<string>, adultCare?: boolean, pediatricCare?: boolean, serviceFormatOnLine?: boolean, serviceFormatPresential?: boolean, state?: string, referenceCity?: Array<string>, amountMin?: number, amountMax?: number, billingUnit?: string, status?: string, availability?: Array<number>, emergencyServiceAvailability?: Array<number>, page?: number, size?: number, sortBy?: string, sortDirection?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json',}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (councilGroup !== undefined && councilGroup !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>councilGroup, 'councilGroup');
        }
        if (professionName !== undefined && professionName !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>professionName, 'professionName');
        }
        if (specialty !== undefined && specialty !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>specialty, 'specialty');
        }
        if (activityAreas) {
            activityAreas.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'activityAreas');
            })
        }
        if (adultCare !== undefined && adultCare !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>adultCare, 'adultCare');
        }
        if (pediatricCare !== undefined && pediatricCare !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>pediatricCare, 'pediatricCare');
        }
        if (serviceFormatOnLine !== undefined && serviceFormatOnLine !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>serviceFormatOnLine, 'serviceFormatOnLine');
        }
        if (serviceFormatPresential !== undefined && serviceFormatPresential !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>serviceFormatPresential, 'serviceFormatPresential');
        }
        if (state !== undefined && state !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>state, 'state');
        }
        if (referenceCity) {
            referenceCity.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'referenceCity');
            })
        }
        if (amountMin !== undefined && amountMin !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>amountMin, 'amountMin');
        }
        if (amountMax !== undefined && amountMax !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>amountMax, 'amountMax');
        }
        if (billingUnit !== undefined && billingUnit !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>billingUnit, 'billingUnit');
        }
        if (status !== undefined && status !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>status, 'status');
        }
        if (availability) {
            availability.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'availability');
            })
        }
        if (emergencyServiceAvailability) {
            emergencyServiceAvailability.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'emergencyServiceAvailability');
            })
        }
        if (page !== undefined && page !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>page, 'page');
        }
        if (size !== undefined && size !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>size, 'size');
        }
        if (sortBy !== undefined && sortBy !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>sortBy, 'sortBy');
        }
        if (sortDirection !== undefined && sortDirection !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>sortDirection, 'sortDirection');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (bearerAuth) required
        localVarCredential = this.configuration.lookupCredential('bearerAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }



        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/search_service`;
        return this.httpClient.request<PagedModel>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param searchServiceRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchOffering(searchServiceRequest: SearchServiceRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<PagedModel>;
    public searchOffering(searchServiceRequest: SearchServiceRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<HttpResponse<PagedModel>>;
    public searchOffering(searchServiceRequest: SearchServiceRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<HttpEvent<PagedModel>>;
    public searchOffering(searchServiceRequest: SearchServiceRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json',}): Observable<any> {
        if (searchServiceRequest === null || searchServiceRequest === undefined) {
            throw new Error('Required parameter searchServiceRequest was null or undefined when calling searchOffering.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (bearerAuth) required
        localVarCredential = this.configuration.lookupCredential('bearerAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }



        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/search_service/offering`;
        return this.httpClient.request<PagedModel>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                body: searchServiceRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param councilGroup 
     * @param professionName 
     * @param specialty 
     * @param activityAreas 
     * @param adultCare 
     * @param pediatricCare 
     * @param serviceFormatOnLine 
     * @param serviceFormatPresential 
     * @param state 
     * @param referenceCity 
     * @param amountMin 
     * @param amountMax 
     * @param billingUnit 
     * @param status 
     * @param availability 
     * @param emergencyServiceAvailability 
     * @param page 
     * @param size 
     * @param sortBy 
     * @param sortDirection 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchOfferingGet(councilGroup?: string, professionName?: string, specialty?: string, activityAreas?: Array<string>, adultCare?: boolean, pediatricCare?: boolean, serviceFormatOnLine?: boolean, serviceFormatPresential?: boolean, state?: string, referenceCity?: Array<string>, amountMin?: number, amountMax?: number, billingUnit?: string, status?: string, availability?: Array<number>, emergencyServiceAvailability?: Array<number>, page?: number, size?: number, sortBy?: string, sortDirection?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<PagedModel>;
    public searchOfferingGet(councilGroup?: string, professionName?: string, specialty?: string, activityAreas?: Array<string>, adultCare?: boolean, pediatricCare?: boolean, serviceFormatOnLine?: boolean, serviceFormatPresential?: boolean, state?: string, referenceCity?: Array<string>, amountMin?: number, amountMax?: number, billingUnit?: string, status?: string, availability?: Array<number>, emergencyServiceAvailability?: Array<number>, page?: number, size?: number, sortBy?: string, sortDirection?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<HttpResponse<PagedModel>>;
    public searchOfferingGet(councilGroup?: string, professionName?: string, specialty?: string, activityAreas?: Array<string>, adultCare?: boolean, pediatricCare?: boolean, serviceFormatOnLine?: boolean, serviceFormatPresential?: boolean, state?: string, referenceCity?: Array<string>, amountMin?: number, amountMax?: number, billingUnit?: string, status?: string, availability?: Array<number>, emergencyServiceAvailability?: Array<number>, page?: number, size?: number, sortBy?: string, sortDirection?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<HttpEvent<PagedModel>>;
    public searchOfferingGet(councilGroup?: string, professionName?: string, specialty?: string, activityAreas?: Array<string>, adultCare?: boolean, pediatricCare?: boolean, serviceFormatOnLine?: boolean, serviceFormatPresential?: boolean, state?: string, referenceCity?: Array<string>, amountMin?: number, amountMax?: number, billingUnit?: string, status?: string, availability?: Array<number>, emergencyServiceAvailability?: Array<number>, page?: number, size?: number, sortBy?: string, sortDirection?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json',}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (councilGroup !== undefined && councilGroup !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>councilGroup, 'councilGroup');
        }
        if (professionName !== undefined && professionName !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>professionName, 'professionName');
        }
        if (specialty !== undefined && specialty !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>specialty, 'specialty');
        }
        if (activityAreas) {
            activityAreas.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'activityAreas');
            })
        }
        if (adultCare !== undefined && adultCare !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>adultCare, 'adultCare');
        }
        if (pediatricCare !== undefined && pediatricCare !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>pediatricCare, 'pediatricCare');
        }
        if (serviceFormatOnLine !== undefined && serviceFormatOnLine !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>serviceFormatOnLine, 'serviceFormatOnLine');
        }
        if (serviceFormatPresential !== undefined && serviceFormatPresential !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>serviceFormatPresential, 'serviceFormatPresential');
        }
        if (state !== undefined && state !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>state, 'state');
        }
        if (referenceCity) {
            referenceCity.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'referenceCity');
            })
        }
        if (amountMin !== undefined && amountMin !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>amountMin, 'amountMin');
        }
        if (amountMax !== undefined && amountMax !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>amountMax, 'amountMax');
        }
        if (billingUnit !== undefined && billingUnit !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>billingUnit, 'billingUnit');
        }
        if (status !== undefined && status !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>status, 'status');
        }
        if (availability) {
            availability.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'availability');
            })
        }
        if (emergencyServiceAvailability) {
            emergencyServiceAvailability.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'emergencyServiceAvailability');
            })
        }
        if (page !== undefined && page !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>page, 'page');
        }
        if (size !== undefined && size !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>size, 'size');
        }
        if (sortBy !== undefined && sortBy !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>sortBy, 'sortBy');
        }
        if (sortDirection !== undefined && sortDirection !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>sortDirection, 'sortDirection');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (bearerAuth) required
        localVarCredential = this.configuration.lookupCredential('bearerAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }



        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/search_service/offering`;
        return this.httpClient.request<PagedModel>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
